import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actionCreators from 'src/stores/action-creators';

export const useAction = () => {
    const dispatch = useDispatch();

    return bindActionCreators(actionCreators, dispatch);
}